// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__APJ5q","errorLogs":"styles_errorLogs__3I2Kb"};